import React, { createContext, useState } from "react";

export const AiInitialContext = createContext({});
const AiContextProvider = ({ children }) => {
  const [aiResponseInitial, setAiResponseInitial] = useState({});
  return (
    <AiInitialContext.Provider
      value={{ aiResponseInitial, setAiResponseInitial }}
    >
      {children}
    </AiInitialContext.Provider>
  );
};

export default AiContextProvider;
